import styled from 'styled-components';
import indents from '../../../../../../../constants/js/indents.js';
import { textSizeStyles } from '../../../../../../../mixins/text/textSizeWeight';
import { textOverflowEllipsis } from '../../../../../../../mixins/text/textOverflowEllipsis';
import { getColorStylesLegacy } from '../../../../../../../mixins/text/textColorLegacy';
import { transitionCssMixin } from '../../../../../../../mixins/custom';
const placeholderFs = 16;
const labelFs = 12;
export const StyledContainer = styled.label.withConfig({
  componentId: "FloatBase__sc-14xqf3t-0"
})(["display:block;width:100%;"]);
export const StyledFieldName = styled.div.withConfig({
  componentId: "FloatBase__sc-14xqf3t-1"
})(["", " ", " position:absolute;pointer-events:none;top:0;transform:translateY(11px) scale(calc(", " / ", "));will-change:transform;transform-origin:left;", " ", " width:calc( (", " / ", ") * 100% );input:focus + &,input:placeholder-shown + &,input[value]:not(input[value='']) + &,input[data-value='true'] + &{transform:none;pointer-events:auto;}"], textSizeStyles('fs12'), getColorStylesLegacy('secondary'), placeholderFs, labelFs, transitionCssMixin('transform'), textOverflowEllipsis, labelFs, placeholderFs);
export const StyledWrap = styled.div.withConfig({
  componentId: "FloatBase__sc-14xqf3t-2"
})(["position:relative;& > div:first-child,& > input{padding-top:", ";}"], indents.indentS);